import {Size} from '@jetbrains/ring-ui/components/input/input'
import {Directions} from '@jetbrains/ring-ui/components/popup/popup.consts'
import Select from '@jetbrains/ring-ui/components/select/select'

import type {RepositoryAutocompleteProps} from './PipelineRepositoryAutocomplete.types'
import usePipelineRepositoryAutocomplete from './usePipelineRepositoryAutocomplete'

import styles from './PipelineRepositoryAutocomplete.css'

function PipelineRepositoryAutocomplete({
  repositories,
  disabled,
  selected,
  onChange,
  searchValue,
}: RepositoryAutocompleteProps) {
  const {
    autocompleteFilterIcon,
    autocompleteOptions,
    onChangeSelect,
    notFoundMessage,
    errorMessage,
    autocompleteFilterHandler,
    autocompleteBlurHandler,
    autocompleteKeyDownHandler,
  } = usePipelineRepositoryAutocomplete(repositories, onChange, selected)

  return (
    <div className={styles.autocomplete}>
      <Select
        type={Select.Type.INPUT}
        size={Size.FULL}
        directions={[Directions.BOTTOM_LEFT]}
        inputPlaceholder={'github.com/user/repo.git'}
        selected={selected}
        filter={{value: searchValue, fn: autocompleteFilterHandler}}
        filterIcon={autocompleteFilterIcon}
        disabled={disabled}
        data={autocompleteOptions}
        error={errorMessage}
        notFoundMessage={notFoundMessage}
        label={'Search or paste URL'}
        onChange={onChangeSelect}
        onKeyDown={autocompleteKeyDownHandler}
        onBlur={autocompleteBlurHandler}
        hideArrow
        allowAny
        clear
      />
    </div>
  )
}

export default PipelineRepositoryAutocomplete
